// Package Imports
import { toJS } from "mobx";
import moment from "moment";

// Project Imports
import axios from "utils/axios";
import * as APITypes from "constants/API";
import AuthStore from "modules/login/store/AuthStore";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import incomeTypeEnum from "constants/incomeTypeEnum";
import fetchNeedMaster from "utils/fetchNeedMasterData";
import submitEducationOccupationLocationData from "utils/submitEducationOccupationLocationData";
import FamilyMemberModalTypeEnum from "constants/familyMemberModalTypeEnum";
import StorageKeys from "constants/StorageKeys";
import NeedTypeEnum from "constants/NeedTypeEnum";
import checkIsValueEmpty from "utils/checkIsValueEmpty";
import generateFamilyProductId from "../../../utils/change-la/generateChangeLAFamilyProductId";
import generateAddAssuredFamilyProductId from "modules/optimization/utils/add-assured/generateAddAssuredFamilyProductId";
import generateAddNeedFamilyProductId from "../../../utils/add-need/generateAddNeedFamilyProductId";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../../../../constants/Constants";

const submitDataToTheServer = async (formController, hideProtectionModal, coverAmountType) => {
  //const dataToBeSubmitted = submitEducationOccupationLocationData(formController,OptimizationStore,AuthStore)
  // let response = await axios.post(
  //   APITypes.SAVE_FAMILY_DETAILS,
  //   dataToBeSubmitted
  // )

  // !calling the backend api Fetch BI Data based on provided recommendation
  const formFieldValues = formController.get();
  const targetAmountMidValue = formFieldValues.target_amount_dropdown.value.mid_value;

  ProtectionForFamilyBiDataApiCall(targetAmountMidValue, hideProtectionModal, formController, coverAmountType);
};

const isValidFunction = async (formController) => {
  const validValue = formController.validate({ showErrors: true }).then(({ isValid }) => {
    if (!isValid) {
      console.log("Form errors are ", formController.errors());
    }
    return isValid;
  });

  return validValue;
};

export const onRecommend = async (formController, hideProtectionModal) => {
  const valid = await isValidFunction(formController);

  if (valid) {
    OptimizationStore.isCalculatorUsed = false
    submitDataToTheServer(formController, hideProtectionModal, "recommend");
    //hideProtectionModal()
  }
};

export const onSet = async (formController, hideProtectionModal) => {

  let valid = await isValidFunction(formController);

  let isTargetAmountValueEmpty = checkIsValueEmpty(formController.get().target_amount_dropdown.value)

  if (isTargetAmountValueEmpty) {
    formController.$("target_amount_dropdown").invalidate("This field is mandatory")
    valid = false
  }

  if (valid) {
    OptimizationStore.isCalculatorUsed = false
    submitDataToTheServer(formController, hideProtectionModal);
  }
};

export const onLaunch = async (formController, openProtectionCalculator, getFamilyMemberType) => {
  const valid = await isValidFunction(formController);
  OptimizationStore.needFormController = formController
  if (valid) {
    openProtectionCalculator();
    getFamilyMemberType();
  }
};

export const ProtectionForFamilyBiDataApiCall = async (targetAmountValue, hideModal = OptimizationStore.resetSelectedNeedAndMemberId, formController, coverAmountType) => {
  let needFormController = formController ? formController : OptimizationStore.needFormController
  let masterData = await fetchNeedMaster();

  if (masterData.length <= 0) return;
  let selectedNeedId = masterData.find((singleNeed) => singleNeed.unique_name === OptimizationStore.selectedNeed).id;

  let recommendationReqDataToBeSubmitted = {
    user_journey: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
    family: OptimizationStore.selectedFamilyMemberId,
    need: selectedNeedId,
    target_amount_value: targetAmountValue,
    payout_mode: incomeTypeEnum.LUMPSUM,
  };
  let family = {};
  let formFieldValues = {};
  if (needFormController) {
    const dataToBeSubmitted = submitEducationOccupationLocationData(needFormController, OptimizationStore, AuthStore);
    family = dataToBeSubmitted.family_list[0];
    formFieldValues = needFormController.get();
  }
  let targetAmount = formFieldValues?.target_amount_dropdown?.value?.id ? formFieldValues.target_amount_dropdown.value.id : ""
  switch (OptimizationStore.familyMemberModalType) {
    case FamilyMemberModalTypeEnum.CHANGE_LA:
      const changeLAObj = {
        is_selected: family.is_selected,
        occupation_id: family.occupation,
        education_id: family.education,
        state: family.state,
        office_name: family.office_name,
        pin_code: family.pin_code,
        target_amount: !OptimizationStore.isCalculatorUsed ? targetAmount || null : null,
        target_amount_value: OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
        payout_mode: !OptimizationStore.isCalculatorUsed && targetAmount === "" ? "RECOMMENDED_LUMPSUM" : "lumpsum",
        family: OptimizationStore.selectedFamilyMemberId
      };
      generateFamilyProductId(changeLAObj, hideModal, NeedTypeEnum.PROTECTION_FOR_MY_FAMILY)
      return;

    case FamilyMemberModalTypeEnum.ADD_INSURED:
      let familyMemberData = OptimizationStore.fetchFamilyMemberListForLifeAssured().find((item) => item.id === OptimizationStore.selectedFamilyMemberId);
      const selectedProductForInsured = formFieldValues.products_list.value?.package_id
      const selectedProductRiskForInsured = formFieldValues.products_list.value?.risk
      const addInsuredObj = {
        family_member_id: familyMemberData.id,
        user_journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        need_id: selectedNeedId,
        is_selected: family.is_selected,
        occupation_id: family.occupation,
        education_id: family.education,
        state: family.state,
        office_name: family.office_name,
        pin_code: family.pin_code,
        is_calculator_used: OptimizationStore.isCalculatorUsed,
        monthly_income: familyMemberData.monthly_income,
        dob: familyMemberData.dob,
        target_amount_id: !OptimizationStore.isCalculatorUsed ? targetAmount || null : null,
        target_amount_value: OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
        payout_mode: !OptimizationStore.isCalculatorUsed && targetAmount === "" ? "RECOMMENDED_LUMPSUM" : "lumpsum",
        "selected_product_package_id": selectedProductForInsured ? selectedProductForInsured : null,
        "selected_product_risk": selectedProductRiskForInsured ? selectedProductRiskForInsured : null

      };
      generateAddAssuredFamilyProductId(addInsuredObj, hideModal, NeedTypeEnum.PROTECTION_FOR_MY_FAMILY)
      return;

    case FamilyMemberModalTypeEnum.ADD_NEED:
      let journeyData = toJS(AuthStore.journeyData)
      let memberData = journeyData.family_details_list.find((member) => member.id === OptimizationStore.selectedFamilyMemberId)
      const selectedProductForNeed = formFieldValues.products_list.value?.package_id
      const selectedProductRiskForNeed = formFieldValues.products_list.value?.risk
      let familyProductIdRequest = {
        "family_member_id": OptimizationStore.selectedFamilyMemberId,
        "user_journey_id": getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        "need_id": selectedNeedId,
        "is_selected": true,
        "is_removed": false,
        "is_calculator_used": OptimizationStore.isCalculatorUsed,
        "dob": memberData.dob,
        "target_amount_id": !OptimizationStore.isCalculatorUsed ? targetAmount || null : null,
        "target_amount_value": OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
        "payout_mode": !OptimizationStore.isCalculatorUsed && targetAmount === "" ? "RECOMMENDED_LUMPSUM" : incomeTypeEnum.LUMPSUM.toLowerCase(),
        "occupation_id": family.occupation,
        "education_id": family.education,
        "state": family.state,
        "office_name": family.office_name,
        "pin_code": family.pin_code,
        "selected_product_package_id": selectedProductForNeed ? selectedProductForNeed : null,
        "selected_product_risk": selectedProductRiskForNeed ? selectedProductRiskForNeed : null
      }
      generateAddNeedFamilyProductId(familyProductIdRequest, hideModal, NeedTypeEnum.PROTECTION_FOR_MY_FAMILY)

      return

  }
  let responseDataArray = [];
  let biResponse = await axios.post(APITypes.FETCH_BI_DATA_BASED_ON_PROVIDED_RECOMMENDATION, recommendationReqDataToBeSubmitted);

  responseDataArray.push(biResponse.data);

  if (hideModal !== undefined) {
    hideModal();
  }

  OptimizationStore.addNeed({
    data: responseDataArray,
  });
};


export const prefillProductsList = async () => {
  let agentID = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE)
  let isPosp =  localStorage.getItem(StorageKeys.IS_POSP)
  const response = await axios.get(`${APITypes.GET_PRODUCTS_LIST}?agent_id=${agentID}&is_posp=${isPosp}`)
  return response.data;
}